/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_Event_CountInputs */

const en_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const fr_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const de_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const it_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const ru_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const es_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const zh_cn2_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const ja_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const hi_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const pt_pt2_team_share_event_count = /** @type {(inputs: Team_Share_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

/**
* | output |
* | --- |
* | "{count} events" |
*
* @param {Team_Share_Event_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_event_count = /** @type {((inputs: Team_Share_Event_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Event_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_event_count(inputs)
	if (locale === "de") return de_team_share_event_count(inputs)
	if (locale === "it") return it_team_share_event_count(inputs)
	if (locale === "ru") return ru_team_share_event_count(inputs)
	if (locale === "es") return es_team_share_event_count(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_event_count(inputs)
	if (locale === "ja") return ja_team_share_event_count(inputs)
	if (locale === "hi") return hi_team_share_event_count(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_event_count(inputs)
	return en_team_share_event_count(inputs)
});